import { IconProps } from './icon-props';

interface NotificationIconProps extends IconProps {
  hasUnreadNotifications: boolean;
}

export const NotificationIcon = ({
  hasUnreadNotifications,
  ...props
}: NotificationIconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_3449_19128)">
        <path
          d="M10.2681 21C10.4436 21.304 10.6961 21.5565 11.0001 21.732C11.3041 21.9075 11.649 21.9999 12.0001 21.9999C12.3511 21.9999 12.6960 21.9075 13 21.732C13.3041 21.5565 13.5565 21.304 13.7321 21"
          stroke="#35373A"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.9161 2.31402C13.0136 2.0099 12.0516 1.92498 11.1098 2.0663C10.1680 2.20762 9.27329 2.57112 8.49977 3.12673C7.72625 3.68234 7.09611 4.41411 6.66144 5.26152C6.22678 6.10893 6.00009 7.04764 6.00011 8.00002C6.00011 12.499 4.58911 13.956 3.26011 15.327C3.12969 15.4704 3.04372 15.6485 3.01267 15.8398C2.98162 16.0311 3.00683 16.2273 3.08522 16.4045C3.16362 16.5818 3.29182 16.7324 3.45425 16.8381C3.61667 16.9438 3.80632 17.0001 4.00011 17H20.0001C20.1939 17.0001 20.3836 16.9438 20.5460 16.8381C20.7084 16.7324 20.8366 16.5818 20.9150 16.4045C20.9934 16.2273 21.0186 16.0311 20.9876 15.8398C20.9565 15.6485 20.8705 15.4704 20.7401 15.327C20.5343 15.1151 20.3391 14.8932 20.1551 14.662"
          stroke="#35373A"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 11C19.6569 11 21 9.65685 21 8C21 6.34315 19.6569 5 18 5C16.3431 5 15 6.34315 15 8C15 9.65685 16.3431 11 18 11Z"
          fill={hasUnreadNotifications ? '#FF5E5B' : 'none'}
          stroke={hasUnreadNotifications ? '#FF5E5B' : '#35373A'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3449_19128">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
